// Fonte: Drive "3. Tech & Product/IA Repository/01_strategy_company_wide/marketing_assets/INDEX.md"
// (fonte canônica da marca Conducco — brand book + foundations).
export const CONDUCCO_PRIMARY = "#3024E1";
export const CONDUCCO_DARK = "#0F0F1E";
export const CONDUCCO_ACCENT = "#31F7FF";
export const INSIGHTS_BORDER = "#E0E0E0";
export const INSIGHTS_FONT = "Sora, sans-serif";

/** Laranja da marca. Não existe vermelho no shell — é este o tom de atenção. */
export const CONDUCCO_ORANGE = "#E07124";

// Escala de texto do painel. Antes cada card pintava o próprio título com o
// accent, o que deixava tudo da mesma cor e sem hierarquia: título, descrição e
// rótulo competiam pela mesma atenção. O accent agora marca só o que é do
// relatório (ícone, filete, botão); o texto usa esta escala.
export const INSIGHTS_TEXT = "#1A1A2E";
export const INSIGHTS_MUTED = "#6E6E85";
export const INSIGHTS_FAINT = "#9A9AAE";
export const INSIGHTS_SURFACE = "#F7F7FB";
